/**
 * 自定义消息提示库
 * 替代 element-ui 的 Message 组件
 */

// 创建消息容器
let messageContainer = null

function createContainer() {
  if (!messageContainer) {
    messageContainer = document.createElement('div')
    messageContainer.className = 'custom-message-container'
    messageContainer.style.cssText = `
      position: fixed;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 9999;
      display: flex;
      flex-direction: column;
      gap: 10px;
    `
    document.body.appendChild(messageContainer)
  }
  return messageContainer
}

function createMessage(options) {
  const { message, type = 'info', duration = 3000 } = options

  const container = createContainer()

  // 创建消息元素
  const messageEl = document.createElement('div')
  messageEl.className = `custom-message custom-message--${type}`
  messageEl.style.cssText = `
    min-width: 200px;
    padding: 12px 20px;
    border-radius: 4px;
    font-size: 14px;
    color: #fff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    animation: messageSlideIn 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
  `

  // 根据类型设置背景色
  const bgColors = {
    success: '#67c23a',
    warning: '#e6a23c',
    error: '#f56c6c',
    info: '#909399'
  }
  messageEl.style.backgroundColor = bgColors[type] || bgColors.info

  // 图标
  const icons = {
    success: '✓',
    warning: '⚠',
    error: '✕',
    info: 'ℹ'
  }

  messageEl.innerHTML = `
    <span style="margin-right: 8px;">${icons[type] || icons.info}</span>
    <span>${message}</span>
  `

  container.appendChild(messageEl)

  // 自动关闭
  if (duration > 0) {
    setTimeout(() => {
      closeMessage(messageEl)
    }, duration)
  }

  return {
    close: () => closeMessage(messageEl)
  }
}

function closeMessage(el) {
  if (!el || el.closing) return
  el.closing = true
  el.style.animation = 'messageSlideOut 0.3s ease forwards'
  setTimeout(() => {
    if (el.parentNode) {
      el.parentNode.removeChild(el)
    }
  }, 300)
}

// 添加动画样式
function addStyles() {
  if (document.getElementById('custom-message-styles')) return

  const style = document.createElement('style')
  style.id = 'custom-message-styles'
  style.textContent = `
    @keyframes messageSlideIn {
      from {
        opacity: 0;
        transform: translateY(-20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    @keyframes messageSlideOut {
      from {
        opacity: 1;
        transform: translateY(0);
      }
      to {
        opacity: 0;
        transform: translateY(-20px);
      }
    }
  `
  document.head.appendChild(style)
}

// 初始化样式
if (typeof window !== 'undefined') {
  addStyles()
}

// Message 对象
const Message = {
  success(message, duration) {
    return createMessage({ message, type: 'success', duration })
  },
  warning(message, duration) {
    return createMessage({ message, type: 'warning', duration })
  },
  error(message, duration) {
    return createMessage({ message, type: 'error', duration })
  },
  info(message, duration) {
    return createMessage({ message, type: 'info', duration })
  }
}

export default Message
export { Message }



// WEBPACK FOOTER //
// ./src/utils/message.js